module.exports = __webpack_public_path__ + "static/media/symbol-sponsor.f0a3ef82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-sponsor.svg
// module id = ./src/assets/images/symbol-sponsor.svg
// module chunks = 0